export const GATEWAY_CRETE = "GATEWAY_CRETE";
export const GATEWAY_UPDATE = "GATEWAY_UPDATE";
export const GATEWAY_LOAD = "GATEWAY_LOAD";
export const GATEWAY_REMOVE = "GATEWAY_REMOVE";
export const GATEWAY_CONFIG = "GATEWAY_CONFIG";
export const GATEWAY_LIST = "GATEWAY_LIST";
